import React from 'react'
import TypingAnimation from '../../component/TypingAnimation'
import { useLanguage } from '../../i18n/LanguageContext'

const COPY = {
  ja: {
    name: 'きょ げいせん (Hsu Yun Hsuan)',
    role: 'Full Stack Engineer',
    tagline: 'Webアプリケーションのフロントエンド開発を中心に、実務での開発経験があります。',
    stack: 'JavaScript / TypeScript / React / C#',
    ctaExperience: '職務経歴を見る',
    ctaContact: 'お問い合わせ',
  },
  zh: {
    name: '許芸瑄(mako)',
    role: 'Full Stack Engineer',
    tagline: '專注於 Web Application 前端開發，具備實務開發經驗。',
    stack: 'JavaScript / TypeScript / React / C#',
    ctaExperience: '查看經歷',
    ctaContact: '聯絡我',
  },
}

export default function Welcome() {
  const { lang } = useLanguage()
  const t = COPY[lang]

  return (
    <div className="welcomeAni" id="home">
        <div className="welContainer">
          <div className="welContent">
              <h1>{t.name}</h1>
              <h3>{t.role}</h3>
              <TypingAnimation text={t.tagline} />
              <p className="heroStack">{t.stack}</p>
              <div className="heroActions">
                <a href="#experience" className="button">{t.ctaExperience}</a>
                <a href="#contact" className="button buttonOutline">{t.ctaContact}</a>
              </div>
          </div>
        </div>
    </div>
  )
}
